import React from "react";
import { Box, Text } from "@chakra-ui/layout";
import { formatMoney } from "infra/helpers/number";

function CardValorLiquidar({
  title,
  value,
}: {
  title: string;
  value?: number;
}) {
  return (
    <Box bg="gray.100" p="10px" rounded="8px" fontSize="12px">
      {title}
      <Text fontWeight="bold">{formatMoney(value)}</Text>
    </Box>
  );
}

export default CardValorLiquidar;
